if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mediaDetails = {"15x20_03.jpg":{"view":"front","scale":1.12},"15x20_01.jpg":{"view":"contents","scale":1},"15x20_black_clear_box.jpg":{"view":"packaging","scale":1},"15x20_06copy.jpg":{"view":"stack","scale":1},"15x20_02.jpg":{"view":"angle","scale":1},"5x8_Black_Black_Zipper_Single.jpg":{"view":"front","scale":1.12},"5x8_Black_Black_Zipper_group.jpg":{"view":"contents","scale":1},"5x8_Black_Black_Zipper_box.jpg":{"view":"packaging","scale":1},"5x8_Black_Black_Zipper_Four.jpg":{"view":"stack","scale":1},"5x8_Black_Black_Zipper_Single_Perspective.jpg":{"view":"angle","scale":1},"11x50_cc_WebMain.jpg":{"view":"contents","scale":1.16},"11x50_CC_WithBox.jpg":{"view":"packaging","scale":1},"11x50_CC_TwoRolls-2.jpg":{"view":"angle","scale":1},"11_x_25_clear_d9b29452-420d-4b63-8a06-375c65485fda.png":{"view":"material","scale":1},"11x50_CC_AmazonMain.jpg":{"view":"packaging","scale":1},"SPSBOXG-2.jpg":{"view":"angle","scale":1.03},"SPSBOXG-1.jpg":{"view":"front","scale":1},"SPSBOXG-3.jpg":{"view":"hardware","scale":1},"SPSBOXG-4.jpg":{"view":"detail","scale":1},"SPSBOXG-6.jpg":{"view":"tray","scale":1},"SPSBOXG-12.jpg":{"view":"organizer","scale":1},"SBOXG_Open.jpg":{"view":"dividers","scale":1},"SmokeBox-9.jpg":{"view":"interior","scale":1},"Web_StashBoxLifestyle.jpg":{"view":"in_use","scale":1},"SPSBOXG-9-Strap.jpg":{"view":"strap","scale":1},"SPSPACKK-02.jpg":{"view":"angle","scale":1.02},"SPSPACKK-01.jpg":{"view":"front","scale":1},"SPSPACKK-03.jpg":{"view":"rear","scale":1},"SPSPACKK-04.jpg":{"view":"hardware","scale":1},"SPSPACKK-08.jpg":{"view":"tray","scale":1},"SPSPACKK-05.jpg":{"view":"interior","scale":1},"SPSPACKK-06.jpg":{"view":"dividers","scale":1},"SPSPACKK-07.jpg":{"view":"interior","scale":1},"SPSPACKK-10.jpg":{"view":"in_use","scale":1},"ButtonBag-2.jpg":{"view":"front","scale":1.06},"ButtonBag-3.jpg":{"view":"rear","scale":1},"ButtonBag-4.jpg":{"view":"rear","scale":1},"ButtonBag-5.jpg":{"view":"side","scale":1},"ButtonBag-6.jpg":{"view":"angle","scale":1},"ButtonBag-7.jpg":{"view":"detail","scale":1},"ButtonBag-8.jpg":{"view":"hardware","scale":1},"ButtonBag-9.jpg":{"view":"strap","scale":1}};
        this.viewLabels = JSON.parse(this.querySelector('[data-sp-gallery-labels]')?.textContent || '{}');
        this.preparePresentation();
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
          thumbnail.addEventListener('pointerenter', () => {
            const item = this.elements.viewer.querySelector('[data-media-id="' + thumbnail.dataset.target + '"]');
            const image = item?.querySelector('img');
            if (image) image.loading = 'eager';
          });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      preparePresentation() {
        this.elements.viewer.querySelectorAll('.product__media-item').forEach((item) => {
          const image = item.querySelector('img');
          if (!image) return;
          const filename = decodeURIComponent(new URL(image.src, location.href).pathname.split('/').pop());
          const detail = this.mediaDetails[filename];
          if (detail) {
            image.style.setProperty('--sp-image-scale', detail.scale);
            item.dataset.spView = detail.view;
          }
        });
        this.updateViewLabel(this.elements.viewer.querySelector('.is-active'));
      }

      updateViewLabel(item) {
        const caption = this.querySelector('[data-sp-view-label]');
        if (!caption || !item) return;
        const image = item.querySelector('img');
        let view = item.dataset.spView;
        if (!view && image) {
          const text = image.alt.toLowerCase();
          if (text.includes('packaging') || text.includes('retail box')) view = 'packaging';
          else if (text.startsWith('front')) view = 'front';
          else if (text.includes('interior')) view = 'interior';
          else if (text.startsWith('back') || text.startsWith('rear')) view = 'rear';
          else if (text.includes('angled') || text.includes('angle')) view = 'angle';
          else if (text.includes('stack')) view = 'stack';
          else if (text.includes('close-up')) view = 'detail';
          else if (text.includes('model carrying')) view = 'in_use';
        }
        caption.textContent = this.viewLabels[view] || this.viewLabels.view || '';
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.updateViewLabel(event.detail.currentElement);
      }

      async setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.pendingMedia = mediaId;
        const selectedImage = activeMedia.querySelector('img');
        if (selectedImage) {
          selectedImage.loading = 'eager';
          try { await selectedImage.decode(); } catch {}
          if (this.pendingMedia !== mediaId) return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
        this.updateViewLabel(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
